import React, { useCallback, useEffect, useRef, useState } from "react";
import { lightGreen, blue, purple } from "@mui/material/colors";
import { Line } from "react-chartjs-2";
import { SensorProps } from "../../helper/functionSensor";
import { fetchApi } from "../../helper/api";
import { useLocation } from "react-router-dom";
import { UnpackData, UnpackLabel } from "../../helper/functionSensor";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Divider, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "chartjs-adapter-moment";
import ChartAnnotation from "chartjs-plugin-annotation";
import zoomPlugin from "chartjs-plugin-zoom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  registerables,
} from "chart.js";
import InputNumber from "react-input-number";
import { IsAlert } from "../atoms/IsAlert";
import { saveAs } from "file-saver";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartAnnotation,
  zoomPlugin,
  ...registerables
);
const optGraph = (metaSensor, benchmark) => {
  if (metaSensor) {
    return {
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      responsiveAnimationDuration: 0,
      redraw: false,
      scales: {
        y: {
          ticks: {
            // Include a dollar sign in the ticks
            callback: function (value) {
              return value.toFixed(2) + SensorProps[metaSensor?.group].satuan;
            },
          },
          // suggestedMax: SensorProps[metaSensor?.group].max,
          // suggestedMin: SensorProps[metaSensor?.group].min,
          // stepSize: SensorProps[metaSensor?.group].step,
          suggestedMax: benchmark?.max ?? SensorProps[metaSensor?.group].max,
          suggestedMin: benchmark?.min ?? SensorProps[metaSensor?.group].min,
          stepSize: benchmark?.step ?? SensorProps[metaSensor?.group].step,
        },
        x: {
          type: "timeseries",
        },
      },
      elements: {
        point: {
          radius: 0,
          hoverRadius: 0,
          hitRadius: 0,
        },
        line: {
          tension: 0,
        },
      },
      plugins: {
        tooltip: {
          enabled: true,
          //   mode: "index",
          intersect: false,
        },
        hover: {
          mode: "nearest",
          intersect: false,
        },
        zoom: {
          zoom: {
            wheel: {
              enabled: true, // SET SCROOL ZOOM TO TRUE
            },
            mode: "x",
            speed: 10,
          },
          pan: {
            enabled: true,
            mode: "x",
            speed: 10,
          },
        },
      },
    };
  } else {
    return {
      elements: {
        point: {
          radius: 0,
          hoverRadius: 0,
          hitRadius: 0,
        },
        line: {
          tension: 0,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
      },
    };
  }
};

const DefaultGraph = ({ metaSensor, PG }) => {
  const defaultData = {
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
      },
    ],
  };
  let graph = PG.map((graph) => {
    if (graph.show) {
      return (
        <div
          key={graph.name}
          style={{
            display: "flex",
            alignSelf: "center",
            width: "98%",
          }}
        >
          <div
            style={{
              width: "100%",
            }}
          >
            <Line
              key={graph.name}
              options={{
                ...optGraph(metaSensor),
              }}
              data={defaultData}
            />
          </div>
        </div>
      );
    }
  });

  return graph;
};

const PlaybackGraph = React.memo(
  ({ metaSensor, dataForGraph, PG, benchmark }) => {
    let divRef = useRef({});

    const CreateGraph = useCallback(() => {
      let labelAll = [];
      let dataGraph = {};
      for (let i = 0; i < PG.length; i++) {
        dataGraph[PG[i].name] = [];
      }
      // console.log("DATAGRAPh", dataGraph);
      for (let i = 0; i < dataForGraph.length; i++) {
        const raw = dataForGraph[i].buffer.toString().split(",");
        const ts = raw[0];
        const dataToUnpack = raw[1];
        const dataSensor = UnpackData(metaSensor.group, dataToUnpack);
        const labelData = UnpackLabel(
          +ts,
          dataToUnpack.length / (6 * Object.keys(PG).length),
          metaSensor.sampleRate
        );
        labelAll.push(...labelData);
        for (let key in dataSensor) {
          if (dataSensor.hasOwnProperty(key)) {
            dataGraph[key].push(...dataSensor[key]);
          }
        }
      }

      // console.log("LABEL ALL", labelAll);
      // console.log("DATA", dataGraph[PG[0].name]);

      // PG.map((graph, index) => {
      //   divRef.current[graph.name].labels = labelAll;
      //   divRef.current[graph.name].data.datasets[0].data =
      //     dataGraph[graph.name];
      //   divRef.current[graph.name].data.datasets[0].label =
      //     dataGraph[graph.name];
      //   console.log(divRef.current[graph].data);
      // });
      let graph = PG.map((graph, index) => {
        return (
          graph.show && (
            <div
              key={graph.name}
              style={{
                width: "100%",
              }}
            >
              <Line
                key={graph.name}
                options={{
                  ...optGraph(metaSensor, benchmark),
                }}
                data={{
                  ...graph.data,
                  labels: labelAll,
                  datasets: [
                    {
                      ...graph.data.datasets[0],
                      data: dataGraph[graph.name],
                      label: graph.name,
                    },
                  ],
                }}
                ref={(refs) => {
                  divRef.current[graph.name] = refs;
                }}
              />
            </div>
          )
        );
      });
      return graph;
    }, [metaSensor, dataForGraph, benchmark]);

    return CreateGraph();
  }
);

const SwitchGraph = React.memo(({ idSensor, params, sensor, benchmark }) => {
  const [metaSensor, setMetaSensor] = useState(null);
  const [dataForGraph, setDataForGraph] = useState(null);
  const [failed, setFailed] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [PGG, setPGG] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const req = await fetchApi(
        `api/Data/dataPartial?idSensor=${idSensor}&fromTs=${params?.from}&toTs=${params?.to}`,
        "get",
        true
      );
      const res = await req.json();
      if (req.status === 404) {
        console.log("INI ERROR 404", res.message);
        alert(res.message);
        setFailed(true);
      } else if (req?.status !== 400) {
        if (res?.data === undefined) {
          setFailed(true);
        } else {
          console.log("DATA: ", res.data);
          setDataForGraph(res?.data?.dataSensor);
          setMetaSensor(res?.data?.metaSensor);
          setMounted(false);
        }
      } else {
        console.log("ERROR ", res.message);
        alert(res.message);
        setFailed(true);
      }
    };
    if (idSensor && params.from && params.to) {
      fetchData();
    }
  }, [params]);

  useEffect(() => {
    if (sensor) {
      // console.log("GROUP", sensor.group);
      switch (sensor?.group) {
        case "Accelerometer":
          const accX = {
            labels: [],
            datasets: [
              {
                label: "",
                data: [],
                fill: false,
                backgroundColor: lightGreen["800"],
                borderColor: lightGreen["800"],
                borderWidth: 1.5,
                hidden: false,
                // pointRadius: 1,
                // pointHoverRadius: 5,
                // pointHitRadius: 10,
              },
            ],
          };
          const accY = {
            labels: [],
            datasets: [
              {
                label: "",
                data: [],
                fill: false,
                backgroundColor: blue["700"],
                borderColor: blue["700"],
                borderWidth: 1.5,
                hidden: false,
                // pointRadius: 1,
                // pointHoverRadius: 5,
                // pointHitRadius: 10,
              },
            ],
          };
          const accZ = {
            labels: [],
            datasets: [
              {
                label: "",
                data: [],
                fill: false,
                backgroundColor: purple["600"],
                borderColor: purple["600"],
                borderWidth: 1.5,
                hidden: false,
                // pointRadius: 1,
                // pointHoverRadius: 5,
                // pointHitRadius: 10,
              },
            ],
          };
          const accPg = [
            {
              name: `${sensor?.group} X`,
              data: accX,
              show: true,
            },
            {
              name: `${sensor?.group} Y`,
              data: accY,
              show: true,
            },
            {
              name: `${sensor?.group} Z`,
              data: accZ,
              show: true,
            },
          ];
          setPGG(accPg);
          break;

        case "Strain":
          const strX = {
            labels: [],
            datasets: [
              {
                label: "",
                data: [],
                fill: false,
                backgroundColor: lightGreen["800"],
                borderColor: lightGreen["800"],
                borderWidth: 1.5,
                hidden: false,
              },
            ],
          };
          const strPg = [
            {
              name: `${sensor?.group}`,
              data: strX,
              show: true,
            },
          ];
          setPGG(strPg);
          break;

        case "Gyroscope":
          const gyrX = {
            labels: [],
            datasets: [
              {
                label: "",
                data: [],
                fill: false,
                backgroundColor: blue["700"],
                borderColor: blue["700"],
                borderWidth: 1.5,
                hidden: false,
              },
            ],
          };
          const gyrY = {
            labels: [],
            datasets: [
              {
                label: "",
                data: [],
                fill: false,
                backgroundColor: blue["700"],
                borderColor: blue["700"],
                borderWidth: 1.5,
                hidden: false,
              },
            ],
          };
          const gyrZ = {
            labels: [],
            datasets: [
              {
                label: "",
                data: [],
                fill: false,
                backgroundColor: purple["600"],
                borderColor: purple["600"],
                borderWidth: 1.5,
                hidden: false,
              },
            ],
          };
          const gyrPg = [
            {
              name: `${sensor?.group} X`,
              data: gyrX,
              show: true,
            },
            {
              name: `${sensor?.group} Pitch Y`,
              data: gyrY,
              show: true,
            },
            {
              name: `${sensor?.group} Roll Z`,
              data: gyrZ,
              show: false,
            },
          ];
          setPGG(gyrPg);
          break;

        case "LVDT":
          const lvdtX = {
            labels: [],
            datasets: [
              {
                label: "",
                data: [],
                fill: false,
                backgroundColor: lightGreen["800"],
                borderColor: lightGreen["800"],
                borderWidth: 1.5,
                hidden: false,
              },
            ],
          };
          const lvdtPg = [
            {
              name: `LVDT`,
              data: lvdtX,
              show: true,
            },
          ];
          setPGG(lvdtPg);
          break;

        case "Temperature":
          const temp = {
            labels: [],
            datasets: [
              {
                label: "",
                data: [],
                fill: false,
                backgroundColor: lightGreen["800"],
                borderColor: lightGreen["800"],
                borderWidth: 1.5,
                hidden: false,
              },
            ],
          };
          const TempPg = {
            Temperature: {
              ref: null,
              data: temp,
            },
          };
          setPGG(TempPg);
          break;

        case "Power Distribution":
          // if (type === "TD") {
          //   return (
          //     <PowerDistribution topic={`dataStream/${ipcSn}/${sensor.idSensor}`} />
          //   );
          // }
          break;

        default:
          return <>Sensor is not detected...{sensor?.group}</>;
      }
    }
  }, [sensor]);

  if (PGG && !dataForGraph) {
    return <DefaultGraph metaSensor={sensor} PG={PGG} />;
  } else if (!PGG) {
    return <>Loading...</>;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "98%",
        gap: "20px",
        // border: "1px solid red",
      }}
    >
      <PlaybackGraph
        metaSensor={metaSensor}
        PG={PGG}
        dataForGraph={dataForGraph}
        params={params}
        benchmark={benchmark}
      />
    </div>
  );
});

export const PlaybackData = () => {
  const defaultDateValue = { from: null, to: null };
  const { state } = useLocation();
  const [dateValue, setDateValue] = useState(defaultDateValue);
  const [params, setParams] = useState(defaultDateValue);
  const [sensor, setSensor] = useState(null);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [num, setNum] = useState(2.2);
  const [customBenchmark, setCustomBenchmark] = useState({
    max: null,
    min: null,
    step: null,
  });

  // console.log("state", state);

  const handleDate = (type, e) => {
    if (type === "from") {
      setDateValue(defaultDateValue);
      setDateValue((current) => {
        return { ...current, from: e };
      });
      setParams({ from: Date.parse(e), to: null });
    } else if (type === "to") {
      setDateValue((current) => {
        return { ...current, to: e };
      });
      setParams((current) => {
        return { ...current, to: Date.parse(e) };
      });
    }
  };

  useEffect(() => {
    if (!sensor && state?.idSensor) {
      const fetchSensor = async () => {
        const req = await fetchApi(
          `api/Rtu/sensor/${state?.idSensor}`,
          "get",
          true
        );
        const res = await req.json();
        if (req.status === 200) {
          setSensor(res.data);
          setCustomBenchmark({
            max: SensorProps[res.data.group].max,
            min: SensorProps[res.data.group].min,
            step: SensorProps[res.data.group].step,
          });
        }
      };

      fetchSensor();
    }
  }, [state]);

  const handleDownloadPlayback = useCallback(async () => {
    if (!dateValue?.from || !dateValue?.to) {
      IsAlert.fire({
        icon: "warning",
        title: "Perhatian",
        text: "Pastikan tanggal telah terisi terlebih dahulu untuk mendapatkan data playback",
        showCancelButton: false,
        showConfirmButton: true,
      });
      return;
    }
    setLoadingDownload(true);
    try {
      const from = Date.parse(dateValue?.from);
      const to = Date.parse(dateValue?.to);
      const url = `api/Data/downloadPlayback?idSensor=${state?.idSensor}&from=${from}&to=${to}`;
      const filename = `Playback Data ${state?.group} (${state?.numberSensor}) | ${dateValue?.from} - ${dateValue?.to}`;
      const req = await fetchApi(url, "get_blob", true);
      const res = await req.blob();
      saveAs(res, `${filename}.csv`);
    } catch (error) {
    } finally {
      setLoadingDownload(false);
    }
  }, [
    dateValue?.from,
    dateValue?.to,
    state?.group,
    state?.idSensor,
    state?.numberSensor,
  ]);

  //   if (state?.idSensor && state?.params) {
  return (
    <div
      style={{
        padding: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="bg-white shadow p-4 mb-4"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "30px",
          backgroundColor: "white",
          borderRadius: "10px",
          width: "100%",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{ display: "flex", gap: "1em", alignItems: "flex-start" }}
            >
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label
                  style={{
                    fontSize: "14px",
                  }}
                >
                  Batas Atas
                </label>
                <input
                  id="max"
                  type="number"
                  // max={null}
                  min={customBenchmark.min + customBenchmark.step}
                  step={customBenchmark.step}
                  value={customBenchmark.max}
                  onChange={(e) => {
                    const { value } = e.target;
                    // console.log(
                    //   value,
                    //   " -- ",
                    //   customBenchmark.min,
                    //   " -- ",
                    //   customBenchmark.step
                    // );
                    if (
                      Number(value) >=
                      Number(customBenchmark.min) + Number(customBenchmark.step)
                    ) {
                      setCustomBenchmark((current) => {
                        return { ...current, max: value };
                      });
                    }
                  }}
                  className="border rounded"
                  style={{
                    fontSize: "14px",
                    width: "100px",
                    borderRadius: "3px",
                    padding: "15px 10px",
                  }}
                />
              </span>
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label
                  style={{
                    fontSize: "14px",
                  }}
                >
                  Batas Bawah
                </label>
                <input
                  id="min"
                  type="number"
                  // min={null}
                  max={customBenchmark.max - customBenchmark.step}
                  step={customBenchmark.step}
                  value={customBenchmark.min}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (
                      Number(value) <=
                      Number(customBenchmark.max) - Number(customBenchmark.step)
                    ) {
                      setCustomBenchmark((current) => {
                        return { ...current, min: value };
                      });
                    }
                  }}
                  className="border rounded"
                  style={{
                    fontSize: "14px",
                    width: "100px",
                    borderRadius: "3px",
                    padding: "15px 10px",
                  }}
                />
              </span>
              {/* <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label
                  style={{
                    fontSize: "14px",
                  }}
                >
                  Step
                </label>
                <input
                  id="step"
                  type="number"
                  min="0"
                  // max={null}
                  step={SensorProps[sensor?.group]?.step ?? "0.1"}
                  value={customBenchmark.step}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (Number(value) > 0) {
                      setCustomBenchmark((current) => {
                        return {
                          ...current,
                          step: value,
                        };
                      });
                    }
                  }}
                  style={{
                    fontSize: "14px",
                    width: "100px",
                    border: "1px solid #c8c8c8",
                    borderRadius: "3px",
                    padding: "12px 15px",
                  }}
                />
              </span> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "1em",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <label
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      Tanggal Waktu Mulai
                    </label>
                    <DateTimePicker
                      value={dateValue?.from}
                      onChange={(e) => handleDate("from", e)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          className="border rounded p-2"
                          style={{
                            textDecoration: "none",
                            borderBottom: "none",
                          }}
                        />
                      )}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <label
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      Tanggal Waktu Akhir
                    </label>
                    <DateTimePicker
                      value={dateValue?.to}
                      onAccept={(e) => handleDate("to", e)}
                      onChange={(e) => true}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          className="border rounded p-2"
                          style={{
                            textDecoration: "none",
                            borderBottom: "none",
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </LocalizationProvider>
            </div>
            <div className="d-flex align-items-start">
              <button
                className={`btn ${
                  loadingDownload || !dateValue?.from || !dateValue?.to
                    ? "btn-light"
                    : "btn-success"
                } ml-3 d-flex align-items-center`}
                onClick={() => handleDownloadPlayback()}
                disabled={loadingDownload || !dateValue?.from || !dateValue?.to}
              >
                <i className="las la-save mr-2" style={{ fontSize: 24 }}></i>
                Download
              </button>
            </div>
          </div>
        </div>
        <Divider />
        <SwitchGraph
          idSensor={state?.idSensor}
          params={params}
          sensor={sensor}
          benchmark={customBenchmark}
        />
      </div>
    </div>
  );
  //   }
};
